import { combineReducers } from 'redux';
import optionsReducer from './optionsReducer';

const rootReducer = combineReducers({
  optionsReducer
});

export default rootReducer;